import { render } from "./Message.vue?vue&type=template&id=8f0ca2a2"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"
script.render = render

export default script